import { render, staticRenderFns } from "./EventConnectionList.vue?vue&type=template&id=c91a134a"
import script from "./EventConnectionList.vue?vue&type=script&lang=js"
export * from "./EventConnectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports